import { Box } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../component/header";
import Footer from "../component/footer";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box>
      <Header />
      <Box sx={{ minHeight: 'calc(100vh - 140px)' }}>
        <Outlet />
      </Box>
      {pathname !== "/progress" && pathname !== "/result" && pathname !== "/plans" && <Footer />}
    </Box>
  );
}
